/**
 * Legacy HouseholdApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.householdApi`) keep resolving.
 *
 * The actual HouseholdApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/household/household-api.service.ts
 */
angular.module("acme.common.service.householdApi", []);
